import { useQuery } from '@tanstack/react-query';
import { fetchAssessmentById } from '@/api/slcp';
import type { SlcpAssessmentOverview } from '../-types';

export const slcpAssessmentDetailKeys = {
  detail: (id: string) => ['slcp', 'assessment', id] as const,
};

/** Server returns `SlcpAssessmentDetail`; `SlcpAssessmentOverview` only adds
 *  optional fields on top so the assignment is structurally compatible. */
async function fetchAssessmentOverview(
  assessmentId: string,
): Promise<SlcpAssessmentOverview> {
  return fetchAssessmentById(assessmentId);
}

export function useSlcpAssessmentDetail(assessmentId: string) {
  return useQuery({
    queryKey: slcpAssessmentDetailKeys.detail(assessmentId),
    queryFn: () => fetchAssessmentOverview(assessmentId),
    enabled: !!assessmentId,
    staleTime: 60_000,
  });
}
